import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Modal, Typography } from "@mui/material";
import Style from "./feedback.module.css";
import { Upload } from "@mui/icons-material";
import { apiService } from "../../api/apiService";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    borderRadius: "8px",
    p: 2,
};

interface ContactusDialogProps {
    open: boolean;
    onClose: () => void;
}

const ContactusDialog: React.FC<ContactusDialogProps> = ({ open, onClose }) => {
    const { instance } = useMsal();
    const [thankYouOpen, setThankYouOpen] = useState(false);
    const [centerData, setCenterData] = useState<any[]>([]);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const userName = localStorage.getItem("userName") || "";
    const userEmail = localStorage.getItem("userEmail") || "";
    interface UserData {
        name?: string;
        email?: string;
        management?: string;
        type_of_issue?: string;
        message?: string;
    }

    const [userData, setUserData] = useState<UserData>({ name: '', email: '', management: '', type_of_issue: 'Technical', message: '' });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setSelectedFile(event.target.files[0]); // Store the selected file in state
        }
    };

    function handleThankYouClose(event: React.MouseEvent<HTMLButtonElement>): void {
        setThankYouOpen(false);
    }

    const handleSendQuery = async () => {
        const formData = new FormData();
        const payload = {
            management: userData?.management,
            type_of_issue: userData?.type_of_issue,
            name: userData?.name,
            email: userData?.email,
            message: userData?.message,
        };

        formData.append("new_query_req", JSON.stringify(payload));
        if (selectedFile) {
            formData.append("file", selectedFile);
        }
        await apiService("/ops/contact-us", "POST", formData, undefined, instance as PublicClientApplication);
        setThankYouOpen(true);
    }

    useEffect(() => {
        const fetchData = async () => {
            const staticData = await apiService("/static_management", "GET", undefined, undefined, instance as PublicClientApplication);
            setCenterData(staticData?.data?.map((item: { name: string }) => item.name));
            setUserData({ ...userData, management: staticData?.data[4]?.name });
        }
        fetchData();
    }, []);

    return (
        <><Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <DialogTitle sx={{ m: 0, color: '#000', fontSize: "22px", p: 0 }}>Contact Us</DialogTitle>
                <Box>
                    <div style={{ marginTop: "10px" }}>
                        <label>Name</label>
                        <input name="name" value={userName} disabled placeholder="Enter Name" className={Style.inputFeild} onChange={(e) => setUserData({ ...userData, name: e.target.value })} />
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        <label>Email</label>
                        <input name="Email" value={userEmail} disabled placeholder="Enter Email" className={Style.inputFeild} onChange={(e) => setUserData({ ...userData, email: e.target.value })} />
                    </div>
                    <Box sx={{ display: "flex", gap: "10px", width: "100%", mt: "20px" }}>
                        <div style={{ width: "50%" }}>
                            <label>Select Center</label>
                            <select name="center" value={userData?.management} className={Style.inputFeild} onChange={(e) => setUserData({ ...userData, management: e.target.value })}>
                                {centerData.map((item, index) => (
                                    <option key={index} value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <div style={{ width: "50%" }}>
                            <label>Type of Issue</label>
                            <select name="issue" value={userData?.type_of_issue} className={Style.inputFeild} onChange={(e) => setUserData({ ...userData, type_of_issue: e.target.value })}>
                                <option key={0} value={'Technical'}>Technical</option>
                                <option key={1} value={'Functional'}>Functional</option>
                            </select>
                        </div>
                    </Box>
                    <div style={{ marginTop: "20px" }}>
                        <label>Message</label>
                        <textarea name="Message" rows={4} className={Style.inputFeild} onChange={(e) => setUserData({ ...userData, message: e.target.value })} />
                    </div>
                    <Box
                        sx={{
                            border: '1.5px dashed #000',
                            borderRadius: 3,
                            display: 'flex',
                            flexFlow: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '150px',
                            padding: '10px',
                            textAlign: 'center',
                            mt: "20px"
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onClick={() => document.getElementById('file-input')?.click()}
                    >
                        <input
                            type="file"
                            id="file-input"
                            hidden
                            accept=".jpg,.jpeg,.png,.pdf,.pptx,.docx,.doc,.ppt,.xlsx,.xls,.xlsm" 
                            onChange={handleFileChange}/>
                        <Upload fontSize="large" />
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Drag & Drop or <span style={{ color: '#2563EB' }}>Choose file</span> to upload
                        </Typography>
                        {selectedFile && (
                            <Typography variant="body2" sx={{ mt: 1, color: '#666' }}>
                                Selected File: {selectedFile.name}
                            </Typography>
                        )}
                    </Box>
                </Box>
                <DialogActions sx={{ mt: "20px" }}>
                    <Button variant="outlined" onClick={onClose} sx={{ color: '#000', borderColor: '#000' }}>Cancel</Button>
                    <Button variant="contained" onClick={() => {
                        onClose();
                        handleSendQuery();
                    }} sx={{ background: '#000', color: '#fff' }}>Send</Button>
                </DialogActions>
            </Box>
        </Modal>

            <Dialog open={thankYouOpen} onClose={handleThankYouClose}>
                <DialogTitle></DialogTitle>
                <DialogContent>
                    <Box sx={{ backgroundColor: "#DEFFE3", borderRadius: "10px", width: "60px", height: "60px", display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
                            <path d="M9.44998 17.85L3.84998 12.25L4.92498 11.175L9.44998 15.7L19.05 6.09998L20.125 7.17498L9.44998 17.85Z" fill="#0E711D" />
                        </svg>
                    </Box>
                    <Box sx={{ mt: "20px" }}>
                        <Typography sx={{ fontSize: "20px !important", fontWeight: "600", textAlign: "left" }}>
                            Thank you for connecting Us!
                        </Typography><br />
                        <Typography sx={{ fontSize: "16px !important", fontWeight: "400", textAlign: "left", color: "#666666 !important" }}>We’ve received your message we followup shortly.</Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'flex-start', ml: "20px", mb: "20px" }}>
                    <Button sx={{
                        display: "flex",
                        justifyContent: "center",
                        borderRadius: "8px",
                        background: "#EFEFEF",
                        color: "#666666",
                        fontWeight: "600",
                        padding: "8px 14px",
                        fontSize: "16px !important"
                    }} onClick={(event) => handleThankYouClose(event)} autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog></>
    );
};

export default ContactusDialog;
